export default __webpack_public_path__ + "static/media/Union (1).46a76d63.svg";